import styled from 'styled-components';

import { Button } from '@cognite/cogs-core-v11/components/button/button.tsx';
import { Tabs as CogsTabs } from '@cognite/cogs-core-v11/components/tabs/tabs.tsx';
import { Flex } from '@cognite/cogs-core-v11/components/flex/flex.tsx';

export const ConfigWrapper = styled.div`
  padding: 12px;
`;

export const Wrapper = styled(Flex)`
  padding: 16px;
  height: calc(100vh - 325px);
`;

export const SaveButton = styled(Button)`
  width: 200px;
`;

export const FixedSaveButtonWrapper = styled.div`
  position: fixed;
  bottom: 16px;
`;

export const Tabs = styled(CogsTabs)`
  .rc-tabs-nav {
    border-bottom: 1px solid ${({ theme }) => theme['border--muted']};
  }
  .rc-tabs-content {
    height: calc(100vh - 106px);
  }
`;

export const TabPane = styled(CogsTabs.Tab)`
  padding: 8px;
  height: 100%;
`;

export const TitleContainer = styled(Flex).attrs({
  alignItems: 'center',
  gap: 16,
})`
  height: 100%;
  padding: 0px 16px;
`;
